import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import axios from 'axios';
import api from './../utils/api';

const CreateUnitDialog = ({ open, onClose, onCreated }) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const superAdminId = user?.id;

  const [unitName, setUnitName] = useState('');

  const handleSave = async () => {
    try {
      await api.post(`api/units/create`, {
        name: unitName,
        superAdminId,
      });
      setUnitName('');
      onCreated(); // trigger refresh
      onClose(); // close dialog
    } catch (err) {
      console.error(err);
      alert('Failed to create unit');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Create New Unit</DialogTitle>
      <DialogContent>
        <TextField
          label="Unit Name"
          fullWidth
          autoFocus
          margin="normal"
          value={unitName}
          onChange={(e) => setUnitName(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button variant="contained" onClick={handleSave}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateUnitDialog;
